import { authenticatedLexterApi } from "@/core/api";

export const FeedbackService = {
  sendFeedback: async (message: string) => {
    const response = await authenticatedLexterApi.post("/feedback", { message });
    return response.data;
  },
};
